import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DesignEditorPreviewPane = ({ className, children }) => {
  const classes = classNames({
    'design-editor-preview-pane': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

DesignEditorPreviewPane.propTypes = propTypes;

export default DesignEditorPreviewPane;
